import LoginIcon from '@mui/icons-material/Login';
import type {SxProps} from '@mui/material';
import {Button} from '@mui/material';
import Box from '@mui/material/Box';
import type * as React from 'react';
import {useNavigate} from 'react-router-dom';

type Props = {
    sx?: SxProps;
};

const GuestHeaderLinks = ({sx}: Props): React.ReactElement => {
    const navigate = useNavigate();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'row',
                mr: 3,
                mt: 4,
                ...sx,
            }}
        >
            <Button
                component='label'
                startIcon={<LoginIcon />}
                onClick={() => navigate('/sign-in')}
                sx={{
                    flexDirection: 'column',
                    gap: 1,
                    color: '#000',
                }}
            >
                Sign-In
            </Button>
        </Box>
    );
};

export default GuestHeaderLinks;
